import { render, staticRenderFns } from "./ReferenceSettings.vue?vue&type=template&id=dab61762&scoped=true"
import script from "./ReferenceSettings.vue?vue&type=script&lang=js"
export * from "./ReferenceSettings.vue?vue&type=script&lang=js"
import style0 from "./ReferenceSettings.vue?vue&type=style&index=0&id=dab61762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab61762",
  null
  
)

export default component.exports